import React from "react";

export function Panel({ title, subtitle, children, testId, className = "" }) {
  return (
    <div className={`k-card p-5 ${className}`} data-testid={testId}>
      <div className="flex items-baseline justify-between gap-3 flex-wrap">
        <h3 className="text-sm font-heading font-bold text-[#212121]">{title}</h3>
        {subtitle && <span className="text-xs text-[#6B7280]">{subtitle}</span>}
      </div>
      <div className="mt-4">{children}</div>
    </div>
  );
}
